module.exports = __webpack_public_path__ + "static/media/Slide5.36899423.png";